<template>
  <form @submit.prevent="onSubmit">
    <p v-if="messageSuccess" class="mt-0 text-center text-success">
      <b>{{ messageSuccess ? messageSuccess : '' }}</b>
    </p>
    <p v-if="messageFailure" class="mt-0 text-center text-danger">
      <b>{{ messageFailure ? messageFailure : '' }}</b>
    </p>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="championnat_nom">Nom ou Titre</label>
      </div>
      <input id="championnat_nom"
             v-model="dataForm.nom"
             class="form-control"
             name="championnat_nom"
             placeholder="Entrez un le nom du championnat"
             type="text">
    </div>
    <div class="mt-4 mb-3 text-center">
      <button class="btn btn-sm btn-success" type="submit">SAUVEGARDER</button>
    </div>
  </form>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex'

export default {
  name: "Create",
  props: {},
  data() {
    return {
      messageSuccess: '',
      messageFailure: '',
      dataForm: {
        nom: '',
        table: 'championnats',
      }
    }
  },
  watch: {
    messageSuccess : function () {
      let vm = this;
      setTimeout( () => vm.messageSuccess = "", 5000)
    },
    messageFailure : function () {
      let vm = this;
      setTimeout( () => vm.messageFailure = "", 5000)
    }
  },
  components: {},
  methods: {
    ...mapMutations([]),
    ...mapActions([
      'axiosPostData',
    ]),
    onSubmit() {
      this.axiosPostData(this.dataForm)
          .then((data) => {
            if((data.data.status === 'reussite' && data.status) === 201)
              this.messageSuccess = "Championnat ajouté avec succès !"
            else
              this.messageFailure = "Une erreur est survenue lors de l'insertion du championnat !"
          })
          .catch((error) => {
            this.messageFailure = "Une erreur est survenue lors de l'insertion du championnat !"
          })
    }
  },
  computed: {
    ...mapGetters([])
  },
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  }
}
</script>

<style lang="scss" scoped>
form {
  & > div {
    & > div {
      & > span, & > label {
        background-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
        color: var(--color-white, rgba(255, 255, 255, 1));
        border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
      }

      & > span.customized-span {
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
        line-height: 1.5;
        border-radius: 0.2rem;
      }
    }

    & > input, & > select {
      border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/championnats/components/Create.vue